<template>
  <div id="vwaTracing" style="font-family: 'Montserrat';">
    <v-toolbar color="#F9FAFD" dark class="toolbar-card" style="height: 80px;">
      <v-toolbar-title style="font-size: 24px; font-weight: 600; line-height: 32px; height: 32px; color: #161A40; font-family: 'Montserrat';">VWA Tracing</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon small @click="initEmployerInfo()" color="#3F4360">
        <img
          :src="computeRefreshLogo"
          alt="Refresh"
          class="height-24"
        />
      </v-btn>
    </v-toolbar>
    <v-container>
      <template>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-text-field
            v-model="employerInfo.agentName"
            label="Assigned Agent"
            disabled
          ></v-text-field>
          <v-text-field
            v-model="employerInfo.name"
            label="Employer Full Name"
          ></v-text-field>

          <v-text-field
            v-model="employerInfo.email"
            :rules="[v => !v || /^\w+([-+.]\w+)*@\w+([-.]\w+)*$/.test(v) ]"
            label="Employer Email"
          ></v-text-field>

          <v-text-field
            v-model="employerInfo.faxNumber"
            label="Employer Fax Number"
            :rules="[v => !v || /^\d{10,}$/.test(v.replace(/[^0-9]/ig, '')) ]"
            v-mask="mask.phone"
          ></v-text-field>
          <v-text-field
            v-model="employerInfo.phoneNumber"
            label="Employer Phone Number"
            :rules="[v => !v || /^\d{10,}$/.test(v.replace(/[^0-9]/ig, '')) ]"
            v-mask="mask.phone"
          ></v-text-field>
          <v-text-field
            v-model="employerInfo.address"
            label="Employer Address Line"
          ></v-text-field>

          <v-select
            v-model="employerInfo.state"
            :items="statesItems"
            label="Employer State"
            required
          ></v-select>

          <v-text-field
            v-model="employerInfo.zip"
            label="Employer Zip"
          ></v-text-field>

          <v-select
            v-model="employerInfo.vwaReasonValue"
            :items="vwaReasonItems"
            label="VWA Reason"
          ></v-select>

          <v-select
            v-model="employerInfo.authorizationType"
            :rules="[v => !!v ]"
            :items="typeItems"
            label="Authorization Type"
            required
          ></v-select>
          <v-textarea
            rows="2"
            label="Note"
            v-model="employerInfo.note"
            hide-details
          ></v-textarea>
        </v-form>
      </template>
    </v-container>

    <v-btn
      text
      v-if="isShowSendEmail"
      :disabled="disable"
      color="primary"
      class="float-lg-left"
      @click="sendEmailToCustomer"
    >
      <v-icon left>
        email
      </v-icon>
      Send Email To Customer
    </v-btn>
    <v-spacer></v-spacer>
    <v-btn
      text
      :disabled="!valid"
      class="float-lg-right"
      @click="save"
    >
    <v-icon left>
      save
    </v-icon>
      Save
    </v-btn>
  </div>
</template>
<script>
import { DataType, Popup, Tool } from '@/util/index'
import { SystemEnum } from '@/assets/js'
import { PaymentApi, CollectionApi } from '@/api/pandaria'
import refreshImg from '@/assets/icons/icon_refresh@3x.png'
const tool = new Tool()
const popup = new Popup()
export default {
  name: 'vwa-tracing',
  props: {
    loan: Object,
    collectionProvider: Number
  },
  data () {
    return {
      employerInfo: {
        loanId: null,
        name: '',
        faxNumber: '',
        email: '',
        phoneNumber: '',
        address: '',
        state: '',
        zip: '',
        agentName: '',
        vwaReasonValue: '',
        authorizationType: '',
        note: ''
      },
      mask: {
        phone: '(###) ###-####'
      },
      isShowSendEmail: false,
      disable: false,
      valid: true,
      statesItems: DataType.State,
      typeItems: SystemEnum.AUTHORIZATION_TYPE,
      vwaReasonItems: DataType.VwaReason,
      slaveLoanId: null
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    },
    computeRefreshLogo () {
      return refreshImg
    }
  },
  mounted () {
    this.$eventBus.$on('initEmployerInfo', target => {
      this.isShowSendEmail = this.collectionProvider === DataType.CollectionProviderEnum.WAGE_ASSIGNMENT_IN_HOUSE.value
      this.initEmployerInfo()
    })
  },
  methods: {
    initEmployerInfo (slaveLoanId) {
      const $this = this
      $this.slaveLoanId = slaveLoanId
      const input = { loanId: $this.loan.id }
      PaymentApi.initEmployerInfo(input, function (result) {
        $this.employerInfo = result
        $this.resetValidation()
      }, function (err) {
        popup.popupForError(err.message)
      })
    },
    updateEmployerInfo () {
      const $this = this
      $this.employerInfo.loanId = $this.loan.id
      PaymentApi.updateEmployerInfoInPayment($this.employerInfo, function (result) {
        if (tool.isNotEmpty($this.loan) && $this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
          $this.$route.path.includes('/collection/application/') ? location.reload() : $this.$router.push({ path: '/collection/application/' + $this.$route.params.uuid })
        } else {
          $this.$eventBus.$emit('get-clicked-slave-detail-event', { loanId: $this.loanId })
          $this.$eventBus.$emit('get-installment-status-event', { loanId: $this.loanId })
        }
        popup.popupForSuccess('Operate successfully')
      }, function (err) {
        popup.popupForError(err.message)
      })
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    save () {
      const $this = this
      if ($this.$refs.form.validate()) {
        $this.updateEmployerInfo()
      }
    },
    sendEmailToCustomer () {
      const $this = this
      $this.disable = true
      const loanIdList = []
      const portfolioId = $this.loan.portfolioId
      loanIdList.push($this.loan.id)
      const input = {
        portfolioId: portfolioId,
        loanIdList: loanIdList,
        emailType: DataType.EmailTypeEnum.WA_EMAIL_TYPE.value,
        collectionProvider: DataType.CollectionProviderEnum.WAGE_ASSIGNMENT_IN_HOUSE.value
      }
      popup.popupForWarning('Are you sure send email to customer?', { showCancelButton: true }, function () {
        CollectionApi.sendEmail(input, function () {
          popup.popupForSuccess('Send Success')
        }, function (err) {
          popup.popupForError(err.message)
        })
      })
      $this.disable = false
    }
  },
  watch: {
  },
  destroyed () {
    this.$eventBus.$off('initEmployerInfo')
  }
}
</script>
<style lang="scss" scoped>
  .script-content {
    margin: 5px 0 5px 0 !important;
    padding: 0 !important;
    .script-content-title {
      padding: 10px !important;
    }
    .script-content-text {
      padding: 0px 10px !important;
    }
  }
  .toolbar-card.v-sheet.v-toolbar:not(.v-sheet--outlined) {
    box-shadow: none;
  }
</style>
